import axios from "axios";

// export const API_BASE_URL = "https://api.multyhealth.com";
export const API_BASE_URL = "https://api.arquenda.com";
// export const API_BASE_URL = "http://localhost:8000";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});